import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'
import Switch from '@react/react-spectrum/Switch'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Button from '@react/react-spectrum/Button'
import Tooltip from '@react/react-spectrum/Tooltip'
import Help from '@react/react-spectrum/Icon/HelpOutline'

const Events = ({ screen, disabled, onScreenUpdate }) => {
  return (
    <FieldLabel label='Extra Page View event' labelFor='component-sidebar-event'>
      <Textfield
        id='component-sidebar-event'
        value={screen?.meta?.eventType || ''}
        onChange={onScreenUpdate('eventType')}
        disabled={disabled}
      />
    </FieldLabel>
  )
}

const Advanced = ({ screen, disabled, onScreenUpdate }) => {
  return <ScrollToTopSwitch screen={screen} disabled={disabled} onScreenUpdate={onScreenUpdate} />
}

function ScrollToTopSwitch({ disabled, screen, onScreenUpdate }) {
  return (
    <div style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : null}>
      <Switch
        label='Scroll to top on page load'
        checked={screen?.meta?.shouldScrollToTop === undefined ? true : screen?.meta?.shouldScrollToTop}
        onChange={onScreenUpdate('shouldScrollToTop')}
      />
      <OverlayTrigger placement='top'>
        <Button className='tooltip-btn' variant='tool' icon={<Help />} />
        <Tooltip>
          Allows you to enable/disable the behavior of scrolling to the top of the page when the screen loads.
        </Tooltip>
      </OverlayTrigger>
    </div>
  )
}

export default [
  { label: 'Events', content: Events },
  { label: 'Advanced', content: Advanced },
]
